module.exports = __webpack_public_path__ + "assets/img/65p_316_4.8e5d3648.jpg";